import $i18n, { useI18n } from '@alife/panda-i18n';
import React, { useRef, useState } from 'react';
import { CnMessage, CnDialog } from '@alife/cn-ui';
// import { snapshot, showDrawboard, closeDrawboard } from '@ali/xfeedback-api';
import { getDefer } from '.';
import { RecordAppKey } from './const';
import { uploadFile } from 'src/services';
import { loadXReplay } from './async-load';
export async function initXReplay(appKey = RecordAppKey) {
    await loadXReplay();
    if (!window.xr?.isInitialized()) {
        window.xr?.init?.({
            appKey,
        });
    }
}
export function useRecording() {
    const recordRef = useRef();
    const recordPromiseRef = useRef();
    const [isRecording, setIsRecording] = useState(false);
    return {
        isRecording,
        start() {
            if (recordRef.current) {
                CnMessage.error({
                    content: $i18n.get({
                        id: 'RecordingInProgressPleaseLater',
                        dm: '正在录制中，请稍后',
                    }),
                });
                return;
            }
            recordRef.current = startRecord();
        },
        async stop() {
            if (!recordRef.current) {
                recordPromiseRef.current?.resolve();
                return;
            }
            recordRef.current.stop();
            recordPromiseRef.current.resolve(recordRef.current.info?.()?.id);
            recordRef.current = null;
            setIsRecording(false);
        },
        async startRecord() {
            recordPromiseRef.current = getDefer();
            setIsRecording(true);
            const promise = recordPromiseRef.current.promise;
            promise.finally(() => {
                recordPromiseRef.current = null;
            });
            return promise;
        },
    };
}
export function startRecord() {
    let stopRecording = () => { };
    let getInfo = () => { };
    // 2. 启动录制。
    window.xr?.startRecording().then((context) => {
        // console.log('context', context);
        getInfo = () => context;
        stopRecording = () => {
            context.stopRecording();
        };
    });
    return {
        stop() {
            stopRecording();
        },
        info() {
            return getInfo();
        },
    };
}
export const previewImage = (url, filename) => {
    const { showDrawboard, closeDrawboard } = window.xfeedbackAPI;
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = '*';
        img.src = url;
        img.onload = () => {
            const drawboaard = showDrawboard(img, {
                primaryColor: '#209e85',
                onSubmit: async (canvas) => {
                    canvas.toBlob(async (blob) => {
                        if (blob) {
                            const type = 'image/png';
                            const file = new File([blob], filename, { type });
                            const res = await uploadFile(file);
                            // console.log('res', res);
                            resolve({ ...res, name: filename, type });
                            closeDrawboard(drawboaard);
                        }
                        else {
                            closeDrawboard(drawboaard);
                            reject();
                        }
                    });
                    console.info('Canvas', canvas);
                },
                onCancel: () => {
                    closeDrawboard(drawboaard);
                    reject();
                },
            });
        };
    });
};
let snapshotNum = 0;
export async function startSnapshot() {
    await loadXReplay();
    const { snapshot } = window.xfeedbackAPI;
    const s = await snapshot(RecordAppKey, {
        expirable: false,
        countryCode: 'al',
        // watermarkText: 'tianxin',
        fullPage: true,
    });
    return previewImage(s.previewURL, `${snapshotNum++}.png`);
}
// https://g.alicdn.com/xfeedback/xf/index.js
// let xFeedbackPromise: any = null;
// export async function loadXFeedback() {
//   if(!xFeedbackPromise){
//     xFeedbackPromise = getScript ('https://g.alicdn.com/xreplay/xreplay-api-publisher/0.30.1/xreplay-recorder-api.min.js');
//   }
//   await xFeedbackPromise.catch((err: Error)  => {
//     console.error(err, 'xFeedback load fail');
//     xFeedbackPromise = null;
//     throw err;
//   })
// }
// window.startSnapshot = startSnapshot;
export function XReplyPlayer({ recordingId, onClose, }) {
    const $i18n = useI18n();
    const Player = window.XReplayPlayer;
    if (!Player) {
        console.error('播放器不存在');
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(CnDialog, { title: $i18n.get({
            id: 'Preview',
            dm: '预览',
        }), visible: true, size: 'large', onClose: onClose, footer: false, style: { width: 880 } },
        React.createElement(Player, { width: 832, height: 600, appKey: RecordAppKey, recordingId: recordingId })));
}
